import { render, staticRenderFns } from "./VariableOpenCard.vue?vue&type=template&id=a21b250a&scoped=true&"
import script from "./VariableOpenCard.vue?vue&type=script&lang=js&"
export * from "./VariableOpenCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21b250a",
  null
  
)

export default component.exports